import React, { Component } from "react";
import NewUIOffer from "./offerV3";
import classnames from "classnames";

class Offer extends Component {
  componentDidMount() {
    const { data } = this.props;
    let { imgUrl } = data;
    if (imgUrl.indexOf("cbu01.alicdn.com") > -1) {
      data.imgUrl = `${imgUrl.replace(".jpg", ".220x220.jpg")}?_=2020`;
    }
  } 
  render() {
    const { data, index, buyerTags, idx } = this.props;
    let cbu_ad_sessionid = "";
    let cbu_ad_adgroup_id = "";
    const isP4p = data.isP4p || data.isP4p ? 1 : 0;

    const style = {
      height: "360px",
      width: "222px",
      boxSizing: "border-box",
      position: "relative",
      marginRight: "11px",
      marginBottom: "11px",
    };

    data.isPcSem = true;
    // delete data.loginId
    //添加打点参数
    let { trackInfo } = data;
    if (trackInfo && typeof trackInfo === "string") {
      trackInfo = JSON.parse(trackInfo);
    } else if (!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;

    
    return (
      <div
        className={classnames({offer_exp: data.impressionEurl})}
        data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${data.offerId}^_p_isad@${isP4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}`}
        style={style}
      >
        <NewUIOffer data={data} buyerTags={buyerTags} idx={idx} />
      </div>
    );
  }
}

export default Offer;
